import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';

import { Icon } from '../Icon';
import styles from './PdfPreview.module.scss';
import arrow from 'assets/sprite/arrow.svg';

interface IPdfPreview {
  src: string;
}

export const PdfPreview: FC<IPdfPreview> = ({ src }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const { t } = useTranslation();
  const pdfWidth = 720;

  // eslint-disable-next-line @typescript-eslint/no-shadow
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
    setPageNumber(1);
  }

  function changePage(offset) {
    setPageNumber(prevPageNumber => prevPageNumber + offset);
  }

  function previousPage() {
    changePage(-1);
  }

  function nextPage() {
    changePage(1);
  }

  return (
    <div className={styles.root} style={{ maxWidth: pdfWidth }}>
      <div className={styles.head}>
        <button
          type="button"
          title={t('previous')}
          disabled={pageNumber <= 1}
          onClick={previousPage}
          className={styles.btn}
        >
          <Icon id={arrow.id} viewBox={arrow.viewBox} className={styles.ico} />
        </button>
        <span
          className={styles.blank}
          style={{ flexBasis: pdfWidth }}
          title={`${t('page')} ${pageNumber || 0} of ${numPages || 0}`}
        ></span>
        <button
          type="button"
          title={t('next')}
          disabled={pageNumber >= numPages}
          onClick={nextPage}
          className={styles.btn}
        >
          <Icon id={arrow.id} viewBox={arrow.viewBox} className={styles.ico} />
        </button>
      </div>
      <Document file={src} onLoadSuccess={onDocumentLoadSuccess} className={styles.pdf}>
        <Page pageNumber={pageNumber} className={styles.page} width={pdfWidth} scale={2} />
      </Document>
    </div>
  );
};
